import React from "react";

const BlogPagination = ({ data, currentPage, onPageChange }) => {
  const { TotalPage} = data || {};
  const pageNumbers = [];

  for (let i = 1; i <= TotalPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="flex items-center justify-center">
      <div className="flex items-center gap-2">
        {pageNumbers.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`flex items-center justify-center w-8 h-8 rounded-lg ${
              page === currentPage ? "bg-[#586474] text-white" : "text-black"
            }`}
          >
            {page}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BlogPagination;
